<template>
  <div style="margin-top: 10px;">
    <div>
      <h5 class="sub-title">
        Herramienta Excel de seguimiento para la cadena de Frío
      </h5>
    </div>
    <div class="main">
      <div class="sub-main">
        <h4>Instrucciones</h4>
        <ol>
          <li>
            Descargue la herramienta Excel haciendo click aquí
            <br>
            <br>
            <button
              type="button"
              class="uk-button download"
              @click="downloadExcel"
            >
              <font-awesome-icon icon="download" />&nbsp; Descargar cadena de frío
            </button>
          </li>
          <li>
            Mantenga un registro de sus mediciones de temperaturas para cada una de los productos en cada uno de los pasos de su cadena de Frío.
          </li>
          <li>Use su registro para demostrar a sus clientes que se ha seguido el proceso adecuado</li>
        </ol>
      </div>
      <div class="gif">
        <h4>Use la herramienta Excel según se muestra aquí</h4>
        <img
          src="../../assets/img/excelgif.gif"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import groupProductByProcessMixins from '../../mixins/groupProductByProcessMixins'
export default {
  mixins: [groupProductByProcessMixins],
  computed: {
    ...mapState({
      product: 'product'
    })
  },
  methods: {
    async downloadExcel () {
      const pages = this.groupProductByProcess.map(x => {
        return {
          product: x.product.toUpperCase(),
          columns: x.processes.map(d => {
            return {
              name: d.process,
              subtitle: `(${d.recommendedTemperatureDegreeCelsiusStart}°C a ${d.recommendedTemperatureDegreeCelsiusEnd}°C)`,
              subColumns: ['Fecha', 'Temperatura']
            }
          })
        }
      })
      if (pages.some(d => d.columns.length === 0)) {
        this.$toast.warning('Algunos de sus productos no están completamentes configurados. Favor contáctarse con su administrador.', {
          position: 'top',
          duration: 4000
        })
        return
      }
      const titleFile = `Cadena de frío ${this.product?.companyName}`
      await this.$excelPlugin.downloadFile(pages, [], this.product?.companyName.toUpperCase(), `${titleFile}.xlsx`, null)
    }
  }
}
</script>

<style scoped>
.table{
    margin: 0px auto;
}
.main{
  margin: 50px 0px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
th{
  border: 1px solid rgb(168, 167, 167);
  margin: 0px;
  font-size: 11.5px;
}
.sub-title {
  background: #002c3f;
  padding: 10px;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}
.download {
  width: 100%;
  font-size: 12px;
  margin: 0px;
  min-width: auto;
  text-align: center;
}
.sub-main{
  align-items: center;
  justify-content: center;
  width: 35%;
  min-width: 400px;
  margin: 0px 10px;
}
.download:hover {
  color: rgb(40, 170, 22) !important;
  box-shadow: 0 7px 16px rgb(111, 120, 124);
  transition: all 0.2s ease;
}
thead th{
    background: #014968;
    color: #fff;
    padding: 10px;
}
li{
  margin-top: 30px;
  padding: 0px 10px ;
}
.gif {
  border-style: solid; padding: 15px;
  text-align: center;
  width: 40%;
  min-width: 400px;
}
@media screen and (max-width: 940px ) {
  .main{
    flex-wrap: wrap;
    margin: 20px 0px
  }
  .sub-main{
  width: 85%;
  min-width: 300px;
  margin: 0px 20px;
}
.download{
max-width: 390px;
font-size: 10px;
}
.gif {
  border-style: solid; padding: 15px;
  text-align: center;
  width: 80%;
    min-width: 300px;
    margin: 0px 20px;
}
.sub-title{
  font-size: 10px !important;
}

}
</style>
